import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";
import { TrendingUp, Users, ShieldCheck, Zap, Activity } from "lucide-react";

const benefits = [
  {
    icon: <TrendingUp size={20} />,
    title: "Revenue Growth",
    subtitle: "Optimized Solutions",
    color: "text-green-600",
    bgColor: "bg-green-100",
    barColor: "bg-green-500",
    width: "85%"
  },
  {
    icon: <Users size={20} />,
    title: "User Retention",
    subtitle: "Engaging Experiences",
    color: "text-blue-600",
    bgColor: "bg-blue-100",
    barColor: "bg-blue-500",
    width: "92%"
  },
  {
    icon: <ShieldCheck size={20} />,
    title: "Enterprise Security",
    subtitle: "Data Protection",
    color: "text-red-600",
    bgColor: "bg-red-100",
    barColor: "bg-red-500",
    width: "100%"
  },
  {
    icon: <Zap size={20} />,
    title: "High Performance",
    subtitle: "Lightning Fast",
    color: "text-amber-600",
    bgColor: "bg-amber-100",
    barColor: "bg-amber-500",
    width: "95%"
  },
  {
    icon: <Activity size={20} />,
    title: "Scalability",
    subtitle: "Future Proof",
    color: "text-purple-600",
    bgColor: "bg-purple-100",
    barColor: "bg-purple-500",
    width: "88%"
  }
];

export function FloatingBenefitCard() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % benefits.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  const benefit = benefits[index];

  return (
    <motion.div 
      animate={{ y: [0, -10, 0] }}
      transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      className="absolute -bottom-6 -left-6 bg-white p-6 rounded-xl shadow-xl border border-slate-100 w-72 z-20"
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.5 }}
        >
           <div className="flex items-center gap-4 mb-3">
              <div className={`w-12 h-12 rounded-full ${benefit.bgColor} flex items-center justify-center ${benefit.color} shrink-0`}>
                {benefit.icon}
              </div>
              <div className="flex-1">
                 <p className="text-base font-bold text-slate-900">{benefit.title}</p>
                 <p className="text-xs text-slate-500">{benefit.subtitle}</p>
              </div>
           </div>
           <div className="h-2 w-full bg-slate-100 rounded-full overflow-hidden mt-2">
              <motion.div 
                initial={{ width: 0 }}
                animate={{ width: benefit.width }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className={`h-full ${benefit.barColor}`}
              />
           </div>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
}
